if (!customElements.get('gift-bag')) {
  class GiftBag extends HTMLElement {
    connectedCallback() {
      this.expandButton = this.querySelector('[data-gift-bag-expand]');
      this.panel = this.querySelector('[data-gift-bag-panel]');
      this.addButton = this.querySelector('[data-gift-bag-add]');
      this.qtyWrap = this.querySelector('[data-gift-bag-qty]');
      this.plusButton = this.querySelector('[data-gift-bag-plus]');
      this.minusButton = this.querySelector('[data-gift-bag-minus]');
      this.qtyValue = this.querySelector('[data-gift-bag-qty-value]');
      this.errorElement = this.querySelector('[data-gift-bag-error]');

      this.onExpandClick = this.onExpandClick.bind(this);
      this.onAddClick = this.onAddClick.bind(this);
      this.onPlusClick = this.onPlusClick.bind(this);
      this.onMinusClick = this.onMinusClick.bind(this);

      if (this.expandButton) {
        this.expandButton.addEventListener('click', this.onExpandClick);
      }
      if (this.addButton) {
        this.addButton.addEventListener('click', this.onAddClick);
      }
      if (this.plusButton) {
        this.plusButton.addEventListener('click', this.onPlusClick);
      }
      if (this.minusButton) {
        this.minusButton.addEventListener('click', this.onMinusClick);
      }

      this.syncActionUi();

      if (this.panel && this.classList.contains('is-open')) {
        this.panel.hidden = false;
        this.panel.style.height = 'auto';
        this.panel.style.opacity = '1';
        if (this.expandButton) this.expandButton.setAttribute('aria-expanded', 'true');
      }

      this.maybeAutoRemove().then(() => {
        if (this.isConnected) this.maybeClampQuantity();
      });
    }

    disconnectedCallback() {
      if (this.expandButton) {
        this.expandButton.removeEventListener('click', this.onExpandClick);
      }
      if (this.addButton) {
        this.addButton.removeEventListener('click', this.onAddClick);
      }
      if (this.plusButton) {
        this.plusButton.removeEventListener('click', this.onPlusClick);
      }
      if (this.minusButton) {
        this.minusButton.removeEventListener('click', this.onMinusClick);
      }
    }

    get variantId() {
      return this.dataset.variantId ? String(this.dataset.variantId) : '';
    }

    get quantity() {
      return Number(this.dataset.quantity || 0);
    }

    get lineKey() {
      return this.dataset.lineKey || '';
    }

    get autoRemove() {
      return this.dataset.autoRemove === 'true';
    }

    get hasNonGift() {
      return this.dataset.hasNonGift === 'true';
    }

    get maxQuantity() {
      const max = Number(this.dataset.maxQuantity);
      return Number.isFinite(max) && max > 0 ? max : 1;
    }

    getSections() {
      const cartDrawer = document.querySelector('cart-drawer');
      const mainCartItems = document.getElementById('main-cart-items');
      const mainCartFooter = document.getElementById('main-cart-footer');
      const sections = ['cart-icon-bubble'];

      if (cartDrawer) sections.push('cart-drawer');
      if (mainCartItems) sections.push(mainCartItems.dataset.id);
      if (mainCartFooter) sections.push(mainCartFooter.dataset.id);

      return sections;
    }

    syncActionUi() {
      const active = this.quantity > 0;
      const loading = this.classList.contains('is-loading');
      this.classList.toggle('is-active', active);

      if (this.addButton) this.addButton.hidden = active;
      if (this.qtyWrap) this.qtyWrap.hidden = !active;
      if (this.qtyValue) this.qtyValue.textContent = String(this.quantity);
      if (this.minusButton) this.minusButton.disabled = loading;
      if (this.plusButton) this.plusButton.disabled = loading || this.quantity >= this.maxQuantity;
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      if (this.addButton) this.addButton.disabled = isLoading;
      if (this.expandButton) this.expandButton.disabled = isLoading;
      this.syncActionUi();
    }

    showError(message) {
      if (!this.errorElement) return;
      if (!message) {
        this.errorElement.textContent = '';
        this.errorElement.hidden = true;
        return;
      }
      this.errorElement.textContent = message;
      this.errorElement.hidden = false;
    }

    setPanelOpen(isOpen) {
      if (!this.panel) return;

      this.classList.toggle('is-open', isOpen);
      if (this.expandButton) {
        this.expandButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (isOpen) {
        this.panel.hidden = false;
        if (reduceMotion) {
          this.panel.style.height = 'auto';
          this.panel.style.opacity = '1';
          return;
        }

        this.panel.style.height = '0px';
        this.panel.style.opacity = '0';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.panel.style.height = `${this.panel.scrollHeight}px`;
            this.panel.style.opacity = '1';
          });
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          this.panel.style.height = 'auto';
          this.panel.removeEventListener('transitionend', onEnd);
        };
        this.panel.addEventListener('transitionend', onEnd);
      } else {
        if (reduceMotion) {
          this.panel.hidden = true;
          this.panel.style.height = '';
          this.panel.style.opacity = '';
          return;
        }

        this.panel.style.height = `${this.panel.scrollHeight}px`;
        this.panel.style.opacity = '1';
        requestAnimationFrame(() => {
          this.panel.style.height = '0px';
          this.panel.style.opacity = '0';
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          this.panel.hidden = true;
          this.panel.style.height = '';
          this.panel.style.opacity = '';
          this.panel.removeEventListener('transitionend', onEnd);
        };
        this.panel.addEventListener('transitionend', onEnd);
      }
    }

    onExpandClick(event) {
      event.preventDefault();
      this.showError('');
      this.setPanelOpen(!this.classList.contains('is-open'));
    }

    async onAddClick(event) {
      event.preventDefault();
      this.showError('');
      if (!this.classList.contains('is-open')) this.setPanelOpen(true);
      await this.setQuantity(1);
    }

    async onPlusClick(event) {
      event.preventDefault();
      if (this.quantity >= this.maxQuantity) return;
      await this.setQuantity(this.quantity + 1);
    }

    async onMinusClick(event) {
      event.preventDefault();
      await this.setQuantity(Math.max(this.quantity - 1, 0));
    }

    async setQuantity(nextQuantity) {
      if (!this.variantId || this.classList.contains('is-loading')) return;

      const quantity = Math.min(Math.max(Number(nextQuantity) || 0, 0), this.maxQuantity);
      const current = this.quantity;

      if (quantity === current) {
        this.syncActionUi();
        return;
      }

      this.setLoading(true);

      try {
        let parsedState;

        if (current === 0 && quantity > 0) {
          const response = await fetch(routes.cart_add_url, {
            ...fetchConfig('javascript'),
            body: JSON.stringify({
              items: [{ id: Number(this.variantId), quantity }],
              sections: this.getSections(),
              sections_url: window.location.pathname,
            }),
          });
          parsedState = await response.json();

          if (parsedState.status) {
            this.showError(parsedState.description || parsedState.message || window.cartStrings?.error);
            this.dataset.quantity = String(current);
            this.syncActionUi();
            return;
          }
        } else {
          const response = await fetch(routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: this.lineKey || this.variantId,
              quantity,
              sections: this.getSections(),
              sections_url: window.location.pathname,
            }),
          });
          parsedState = await response.json();

          if (parsedState.errors) {
            this.showError(
              typeof parsedState.errors === 'string' ? parsedState.errors : window.cartStrings?.error
            );
            this.dataset.quantity = String(current);
            this.syncActionUi();
            return;
          }
        }

        this.refreshCart(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gift-bag',
          productVariantId: this.variantId,
          cartData: parsedState,
        });
      } catch (error) {
        console.error(error);
        this.showError(window.cartStrings?.error);
        this.dataset.quantity = String(current);
        this.syncActionUi();
      } finally {
        this.setLoading(false);
      }
    }

    async maybeAutoRemove() {
      if (!this.autoRemove || this.hasNonGift || this.quantity < 1 || !this.variantId) return;
      if (GiftBag.isAutoRemoving) return;

      GiftBag.isAutoRemoving = true;

      try {
        const updates = {};
        updates[this.variantId] = 0;

        const response = await fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            updates,
            sections: this.getSections(),
            sections_url: window.location.pathname,
          }),
        });
        const parsedState = await response.json();
        if (parsedState.errors) return;

        this.refreshCart(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gift-bag-auto-remove',
          productVariantId: this.variantId,
          cartData: parsedState,
        });
      } catch (error) {
        console.error(error);
      } finally {
        GiftBag.isAutoRemoving = false;
      }
    }

    async maybeClampQuantity() {
      if (this.quantity <= this.maxQuantity || !this.variantId) return;
      if (GiftBag.isAutoRemoving || GiftBag.isClamping) return;

      GiftBag.isClamping = true;

      try {
        await this.setQuantity(this.maxQuantity);
      } finally {
        GiftBag.isClamping = false;
      }
    }

    refreshCart(parsedState) {
      if (!parsedState?.sections) {
        window.location.href = routes.cart_url;
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && parsedState.sections['cart-drawer']) {
        const sectionElement = document.getElementById('CartDrawer');
        if (sectionElement) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '#CartDrawer');
          cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
          sectionElement
            .querySelector('#CartDrawer-Overlay')
            ?.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          if (typeof window.bindCartNoteAccordions === 'function') {
            window.bindCartNoteAccordions(sectionElement);
          }
        }
      }

      if (parsedState.sections['cart-icon-bubble']) {
        const iconBubble = document.getElementById('cart-icon-bubble');
        if (iconBubble) {
          iconBubble.innerHTML = this.getSectionInnerHTML(
            parsedState.sections['cart-icon-bubble'],
            '.shopify-section'
          );
        }
      }

      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems && parsedState.sections[mainCartItems.dataset.id]) {
        const contents = mainCartItems.querySelector('.js-contents');
        if (contents) {
          contents.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[mainCartItems.dataset.id],
            '.js-contents'
          );
        }
        document.querySelector('cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      const mainCartFooter = document.getElementById('main-cart-footer');
      if (mainCartFooter && parsedState.sections[mainCartFooter.dataset.id]) {
        const footerSectionHtml = parsedState.sections[mainCartFooter.dataset.id];
        const contents = mainCartFooter.querySelector('.js-contents');
        if (contents) {
          contents.innerHTML = this.getSectionInnerHTML(footerSectionHtml, '.js-contents');
        }
        const giftBag = mainCartFooter.querySelector('#CartGiftBag');
        if (giftBag) {
          giftBag.innerHTML = this.getSectionInnerHTML(footerSectionHtml, '#CartGiftBag');
        }
        mainCartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      if (parsedState.item_count === 0) {
        document.getElementById('CartStickyCheckout')?.remove();
      }
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }

  GiftBag.isAutoRemoving = false;
  GiftBag.isClamping = false;
  customElements.define('gift-bag', GiftBag);
}
